module.exports = __webpack_public_path__ + "img/toolkit-dwg-log.acaf157a.png";